import React from 'react'

interface CircularProgressProps {
    percent: number
    className?: string
    width?: number | string
    height?: number | string
}

const CircularProgress: React.FC<CircularProgressProps> = ({
    percent,
    className,
    width = 16,
    height = 16,
}) => {
    return (
        <svg
            className={`-rotate-90 ${className || ''}`}
            viewBox="0 0 36 36"
            width={width}
            height={height}
        >
            {/* Background circle */}
            <circle
                cx="18"
                cy="18"
                r="16"
                fill="none"
                className="stroke-gray-200"
                strokeWidth="2"
            />
            {/* Progress circle */}
            <circle
                cx="18"
                cy="18"
                r="16"
                fill="none"
                className="stroke-blue-500"
                strokeWidth="3"
                strokeDasharray="100"
                strokeDashoffset={100 - percent}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default CircularProgress
